/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createIsPositive } from '../../factoriesAny.js';
export var isPositiveDependencies = {
  typedDependencies: typedDependencies,
  createIsPositive: createIsPositive
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesIsPositive.generated.js
// module id = 230
// module chunks = 0